export class Environment {
    /**
      * Is this running in the bot framework azure extension (aka Ibiza).
      */
    public static isInBotFrameworkAzureExtension = false;

    /**
      * Is this running in the "legacy" azure portal.
      */
    public static isInAzurePortal = false;
}



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/Environment.ts